import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import {
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    Grid,
    Select,
    FormControl,
    InputLabel,
    MenuItem,
    Slide,
    Fab
} from '@material-ui/core';
import { withSnackbar } from 'notistack';
import AddPhotoAlternateIcon from '@material-ui/icons/AddPhotoAlternate';
import { withTranslation } from 'react-i18next';
import { createClient, updateClient } from '../api/apiClients';
import WrappedTextField from 'common/components/custom/WrappedTextField';
import WrappedFromControlLabel from 'common/components/custom/WrappedFromControlLabel';

const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
});

class CreateOrUpdateClient extends Component {

    emptyClient = {
        isActive: false,
        name: '',
        address: '',
        city: '',
        postalCode: '',
        country: '',
        reportingCurrency: '',
        imageBase64: null
    };

    constructor(props) {
        super(props);
        this.state = {
            isLoading: false,
            initialClient: JSON.parse(JSON.stringify(this.emptyClient)),
            client: JSON.parse(JSON.stringify(this.emptyClient)),
            modelToDelete: JSON.parse(JSON.stringify(this.emptyClient)),
            models: [],
        };
    }

    componentDidUpdate(prevProps, prevState) {
        if (this.props.clientToEdit != null) {
            if (prevState.client.name !== this.props.clientToEdit.name) {
                this.setState({ client: this.props.clientToEdit, initialClient: JSON.parse(JSON.stringify(this.props.clientToEdit)) });
            }
        }
    }

    closeDialog = () => {
        this.props.onClose();
        this.setState({
            client: JSON.parse(JSON.stringify(this.emptyClient))
        });
    }

    handleChange = (event) => {
        const target = event.target;
        const name = target.name;
        const value = target.type === 'checkbox' ? target.checked : target.value;

        let { client } = this.state;

        client[name] = value;
        this.setState({ client: client })
    };


    handleImageChange = (e) => {
        if (e.target.value === "") {
            return
        }
        let { client } = this.state
        let reader = new FileReader();
        let file = e.target.files[0];

        reader.onloadend = () => {
            client.imageBase64 = reader.result
            this.setState({
                file: file,
            });
        }
        reader.readAsDataURL(file)

        this.setState({ client: client });
    }

    createOrUpdateClient = (e) => {

        e.preventDefault();
        const { client } = this.state;

        if (!this.validateForm()) {
            return;
        }

        let base64Img = client.imageBase64 && client.imageBase64.replace(/^data:image\/\w+;base64,/, "");
        client.imageBase64 = base64Img
        let clientId = client.id
        let patchData = {
            clientId,
            client
        }

        let action = this.props.clientToEdit ? updateClient : createClient;
        action(this.props.clientToEdit ? patchData : client).then(response => {
            this.props.enqueueSnackbar(
                this.props.t(this.props.clientToEdit ? 'update_message' : 'create_message', { title: this.props.t('client') }), { variant: 'success' });
            this.closeDialog()
            this.props.getClients()
        }).catch(error => {
            if (error.response.status === 400) {
                this.props.enqueueSnackbar(this.props.t("client_already_exists"), { variant: 'warning' });
            } else {
                this.props.enqueueSnackbar(
                    this.props.t(this.props.clientToEdit ? 'error_update_message' : 'error_create_message'), { variant: 'error' });
            }
        });
    };

    validateForm() {
        let { client } = this.state;
        let valid = true;
        if (!client.name
            || !client.address
            || !client.city
            || !client.postalCode
            || !client.country
            || !client.reportingCurrency
        ) {
            valid = false;
        }
        return valid;
    }

    render() {
        let { client, initialClient } = this.state
        const { reportingCurrency } = this.props

        let reportingCurrencyList;
        if (reportingCurrency && reportingCurrency.length > 0) {
            reportingCurrencyList = reportingCurrency.map((reportingCurrency, index) => {
                return <MenuItem key={index} value={reportingCurrency}>{reportingCurrency}</MenuItem>
            });
        }

        return (
            <Dialog onClose={this.closeDialog} open={this.props.isOpen} TransitionComponent={Transition}>
                <DialogTitle className="dialog-header-custom">{this.props.clientToEdit ? this.props.t("edit_client") : this.props.t("new_client")}</DialogTitle>
                <form onSubmit={this.createOrUpdateClient} autoComplete="off" spellCheck="false">
                    <DialogContent>
                        <Grid container direction="row" spacing={2}>
                            <Grid item container direction="column" xs={12} sm={12} md={12} lg={12} xl={12}>
                                <Grid container direction="row" spacing={2}>
                                    <Grid item container>
                                        <input
                                            style={{ display: 'none' }}
                                            accept="image/*"
                                            id="contained-button-file"
                                            type="file"
                                            onChange={this.handleImageChange}
                                        />
                                        <label htmlFor="contained-button-file">
                                            {client.imageBase64 ? <img
                                                style={{ width: 268, height: 150, cursor: 'pointer' }}
                                                src={client.imageBase64} alt="" /> :
                                                <Fab
                                                    style={{ width: 268, height: 150, borderRadius: '0%' }}
                                                    component="span"
                                                    size="large"
                                                    color="primary">
                                                    <AddPhotoAlternateIcon style={{ fontSize: 60 }} />
                                                    <span>{this.props.t("add_logo")}</span>
                                                </Fab>
                                            }
                                        </label>
                                    </Grid>
                                    <Grid item container>
                                        <WrappedTextField
                                            autoFocus
                                            label={"name"}
                                            name="name"
                                            onChange={this.handleChange}
                                            value={client.name}
                                        />
                                    </Grid>
                                    <Grid item container>
                                        <WrappedTextField
                                            label={"address"}
                                            name="address"
                                            onChange={this.handleChange}
                                            value={client.address}
                                        />
                                    </Grid>
                                </Grid>
                            </Grid>
                            <Grid item container direction="column" xs={12} sm={12} md={12} lg={12} xl={12}>
                                <Grid container direction="row" spacing={2}>
                                    <Grid item container direction="column" xs={6} sm={6} md={6} lg={6} xl={6}>
                                        <Grid item container>
                                            <WrappedTextField
                                                label={"city"}
                                                name="city"
                                                onChange={this.handleChange}
                                                value={client.city}
                                            />
                                        </Grid>
                                    </Grid>
                                    <Grid item container direction="column" xs={6} sm={6} md={6} lg={6} xl={6}>
                                        <Grid item container>
                                            <WrappedTextField
                                                label={"postal_code"}
                                                name="postalCode"
                                                onChange={this.handleChange}
                                                value={client.postalCode}
                                            />
                                        </Grid>
                                    </Grid>
                                </Grid>
                            </Grid>
                            <Grid item container direction="column" xs={12} sm={12} md={12} lg={12} xl={12}>
                                <Grid container direction="row" spacing={2}>
                                    <Grid item container direction="column" xs={6} sm={6} md={6} lg={6} xl={6}>
                                        <Grid item container>
                                            <WrappedTextField
                                                label={"country"}
                                                name="country"
                                                onChange={this.handleChange}
                                                value={client.country}
                                            />
                                        </Grid>
                                    </Grid>
                                    <Grid item container direction="column" xs={6} sm={6} md={6} lg={6} xl={6}>
                                        <Grid item container>
                                            <FormControl variant="outlined" fullWidth>
                                                <InputLabel id="demo-simple-select-outlined-label" margin="dense">{this.props.t("reporting_currency")}</InputLabel>
                                                <Select
                                                    labelId="demo-simple-select-outlined-label"
                                                    id="reportingCurrency"
                                                    name="reportingCurrency"
                                                    value={client.reportingCurrency}
                                                    onChange={this.handleChange}
                                                    label={this.props.t("reporting_currency")}
                                                    size="small"
                                                    margin="dense">
                                                    {reportingCurrencyList}
                                                </Select>
                                            </FormControl>
                                        </Grid>
                                    </Grid>
                                </Grid>
                            </Grid>
                            {this.props.clientToEdit !== null && <Grid item container direction="column" xs={6} sm={6} md={6} lg={6} xl={6}>
                                <Grid container direction="row" spacing={2}>
                                    <Grid item container>
                                        <WrappedFromControlLabel
                                            onChange={this.handleChange}
                                            name="isActive"
                                            checked={client.isActive}
                                            label={"active"}
                                        />
                                    </Grid>
                                </Grid>
                            </Grid>}
                        </Grid>
                    </DialogContent >
                    <DialogActions className={"dialog-actions-fix"}>
                        <Button color="inherit" onClick={this.closeDialog} variant="contained">
                            {this.props.t("close")}
                        </Button>
                        <Button type="submit" color="primary" variant="contained" disabled={this.props.clientToEdit ? (JSON.stringify(client) === JSON.stringify(initialClient)) : !this.validateForm()}>
                            {this.props.clientToEdit ? this.props.t("update") : this.props.t("create")}
                        </Button>
                    </DialogActions>
                </form>
            </Dialog>
        );
    }
}

export default withSnackbar(withRouter(withTranslation()(CreateOrUpdateClient)));
